// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-details{
  position: relative;
}

.details-section {
  position: absolute;
  top: -30px;
  left: 0;
  background-color: var(--branco);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 800px;
}

.details-section  > h3{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

.details-section h3, .details-section h4 {
  color: var(--azul-escuro2);
  font-weight: 600;
  margin-bottom: 15px;
  border-bottom: 2px solid var(--borda);
  padding-bottom: 5px;
}

.details-section p {
  font-size: 1rem;
  color: var(--texto);
  line-height: 1.6;
  margin-bottom: 10px;
}

.details-section p strong {
  color: var(--azul-escuro2);
}

.details-section .visitor-details,
.details-section .address-details,
.details-section .relationship-details,
.details-section .authorization-details,
.details-section .phone-details,
.details-section .file-details,
.details-section .image-details {
  padding: 15px;
  background-color: var(--fundo);
  border-radius: 8px;
  margin-bottom: 15px;
  border-left: 4px solid var(--azul);
}

.details-section a {
  color: var(--azul2);
  text-decoration: none;
  transition: color 0.3s ease;
}

.details-section a:hover {
  color: var(--azul);
  text-decoration: underline;
}

.authorization-image {
  width: 100%;
  max-width: 100px;
  height: auto;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}

.card-actions {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.card-actions h3 {
  color: var(--vermelho);
  margin-bottom: 5px;
  font-weight: 500;
}

.card-actions textarea {
  padding: 10px;
  border: 1px solid var(--borda);
  border-radius: 5px;
  width: 100%;
  height: 100px;
  resize: none;
  transition: border-color 0.3s ease;
}

.card-actions textarea:focus {
  border-color: var(--azul);
  outline: none;
}

.card-actions button {
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.card-actions .accept {
  background-color: var(--verde);
  color: var(--branco);
}

.card-actions .reject {
  background-color: var(--Vermelho);
  color: var(--branco);
}


.view-icon {
  color: var(--azul);
  cursor: pointer;
  transition: color 0.3s ease;
}

.view-icon:hover {
  color: var(--azul2);
}

`, "",{"version":3,"sources":["webpack://./src/pages/Autorizacoes/authorizations.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAMlB;;AALE;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;EAChC;;AAGF;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;EAOE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;;AAGA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".content-details{\n  position: relative;\n}\n\n.details-section {\n  position: absolute;\n  top: -30px;\n  left: 0;\n  background-color: var(--branco);\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  max-width: 800px;\n  >h3{\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n  }\n}\n\n.details-section h3, .details-section h4 {\n  color: var(--azul-escuro2);\n  font-weight: 600;\n  margin-bottom: 15px;\n  border-bottom: 2px solid var(--borda);\n  padding-bottom: 5px;\n}\n\n.details-section p {\n  font-size: 1rem;\n  color: var(--texto);\n  line-height: 1.6;\n  margin-bottom: 10px;\n}\n\n.details-section p strong {\n  color: var(--azul-escuro2);\n}\n\n.details-section .visitor-details,\n.details-section .address-details,\n.details-section .relationship-details,\n.details-section .authorization-details,\n.details-section .phone-details,\n.details-section .file-details,\n.details-section .image-details {\n  padding: 15px;\n  background-color: var(--fundo);\n  border-radius: 8px;\n  margin-bottom: 15px;\n  border-left: 4px solid var(--azul);\n}\n\n.details-section a {\n  color: var(--azul2);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.details-section a:hover {\n  color: var(--azul);\n  text-decoration: underline;\n}\n\n.authorization-image {\n  width: 100%;\n  max-width: 100px;\n  height: auto;\n  border-radius: 5px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-top: 10px;\n}\n\n.card-actions {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.card-actions h3 {\n  color: var(--vermelho);\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.card-actions textarea {\n  padding: 10px;\n  border: 1px solid var(--borda);\n  border-radius: 5px;\n  width: 100%;\n  height: 100px;\n  resize: none;\n  transition: border-color 0.3s ease;\n}\n\n.card-actions textarea:focus {\n  border-color: var(--azul);\n  outline: none;\n}\n\n.card-actions button {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.card-actions .accept {\n  background-color: var(--verde);\n  color: var(--branco);\n}\n\n.card-actions .reject {\n  background-color: var(--Vermelho);\n  color: var(--branco);\n}\n\n\n.view-icon {\n  color: var(--azul);\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.view-icon:hover {\n  color: var(--azul2);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
